import {TypeImplementation, withSystem, Plugins} from '@packages/systems/wfdl';
import {functionOf, TText, TListOfElement} from '@packages/systems/wfdl-ast';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {
  dynamoTextualContentToListOfElements,
  dynamoTextualContentToText,
} from '../transformers';
import {TOption} from '@packages/systems/plugins/Option';
import {TDynamoSlug} from '@packages/systems/plugins-utils/DynamoGateway';

export const SlugType = TypeImplementation.Custom({
  render: () => null,
  icon: TypeImplementation.IconByName(
    qualify(Plugins.name('Basic'), iconName('Text'))
  ),
});

export const dynamoSlugToText = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoSlug)),
      TText
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToText,
} as const;

export const dynamoSlugToListOfElements = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoSlug)),
      TListOfElement
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToListOfElements,
} as const;
